import subscribe from './form'
import allianzInit from './allianz'

$(document).ready(function(){
   allianzInit(subscribe);
});